import React, { useEffect, useState } from "react";
import {toast} from 'react-toastify'
import { Theme } from '../../lib/theme';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
 
  organisationId:string;
  documentId:string;
  token:string
  
}

export interface FeedbackForm {
  satisfaction: string;
  likelihood: string;
  designQuality: string;
  contentQuality: string;
  comments: string;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ isOpen, onClose,organisationId,documentId,token}) => {
    const [formData, setFormData] = useState<FeedbackForm>({
        satisfaction: "3",
        likelihood: "3",
        designQuality: "3",
        contentQuality: "3",
        comments: "",
      });
    
      useEffect(() => {
        if (!isOpen) {
          setFormData({
            satisfaction: "3",
            likelihood: "3",
            designQuality: "3",
            contentQuality: "3",
            comments: "",
          });
        }
      }, [isOpen]);

      const handleChange = (field: keyof FeedbackForm, value: string) => {
        setFormData(prev => ({ ...prev, [field]: value }));
      };

  const handleSubmit =async () => {
    // onSubmit(formData);
    console.log(formData)
     try {
          
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/feedback`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`, 
              },
              body: JSON.stringify({
                organisationI:organisationId,
                documentId:documentId,
                 feedback: formData
              }),
            }
          );
          
          const result = await response.json();
    
          if (response.ok) {
            toast.success("Feedback submitted successfully!");
          } else {
            const message = result.error || ` Unexpected error: ${response.status}`;
            toast.error(message);
          }
        } catch (error) {
          console.error("Feedback submission error:", error);
          toast.error("Could not submit feedback. Please try again.");
        }
    onClose(); 
  };

  if (!isOpen) return null;

  return (
<div className="fixed inset-0 z-50 flex justify-center items-center" style={{ backgroundColor: "rgba(0,0,0,0.3)" }}>
<div className="bg-white lg:p-6 p-3 rounded-2xl shadow-lg w-[90%] lg:w-[60%] h-auto  max-h-[1000px]  overflow-y-auto max-w-3xl flex flex-col gap-4   relative translate-y-2">
    
    <button
      className="absolute lg:top-4 lg:right-4 top-2 right-5 text-xl font-bold"
      style={{ color: Theme.colors.text.weak }}
      onClick={onClose}
      aria-label="Close"
    >
      &times;
    </button>

    <h2
      className="lg:text-xl md:text-lg text-base font-semibold text-center mb-6"
      style={{ color: Theme.colors.text.strong }}
    >
      Presentation Feedback
    </h2>

    <div className="space-y-6">
      {[
        {
          label: "How satisfied are you with the generated presentation?",
          key: "satisfaction",
          minLabel: "Completely unsatisfied",
          maxLabel: "Completely satisfied"
        },
        {
          label: "How likely are you to use this presentation as-it-is or with minor edits?",
          key: "likelihood",
          minLabel: "Not likely at all",
          maxLabel: "Very likely"
        },
        {
          label: "Rate the design quality of the slides.",
          key: "designQuality",
          minLabel: "Extremely Low",
          maxLabel: "Very high"
        },
        {
          label: "Rate the content quality of the slides.",
          key: "contentQuality",
          minLabel: "Extremely Low",
          maxLabel: "Very high"
        },
      ].map((q, idx) => (
        <div key={idx}>
          <label
            className="block text-sm font-medium mb-2"
            style={{ color: Theme.colors.text.strong }}
          >
            {q.label}
          </label>
          <div className="flex justify-between text-xs px-1">
            <span
              className={
                formData[q.key as keyof FeedbackForm] === "1"
                  ? "font-bold"
                  : ""
              }
              style={{
                color:
                  formData[q.key as keyof FeedbackForm] === "1"
                    ? Theme.colors.primary
                    : Theme.colors.text.weak,
              }}
            >
              {q.minLabel}
            </span>
            <span
              className={
                formData[q.key as keyof FeedbackForm] === "5"
                  ? "font-bold"
                  : ""
              }
              style={{
                color:
                  formData[q.key as keyof FeedbackForm] === "5"
                    ? Theme.colors.primary
                    : Theme.colors.text.weak,
              }}
            >
              {q.maxLabel}
            </span>
          </div>
          <input
            type="range"
            min="1"
            max="5"
            step="1"
            value={formData[q.key as keyof FeedbackForm]}
            onChange={(e) =>
              handleChange(q.key as keyof FeedbackForm, e.target.value)
            }
            className="w-full h-2 rounded-lg transition-all"
            style={{
              accentColor: Theme.colors.primary,
              background:
                "linear-gradient(to right, #60A5FA, #A78BFA, #F472B6)",
            }}
          />
        </div>
      ))}

      <div>
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: Theme.colors.text.strong }}
        >
          Any additional comments?
        </label>
        <textarea
          value={formData.comments}
          onChange={(e) => handleChange("comments", e.target.value)}
          className="w-full border rounded p-2"
          rows={3}
          placeholder="Write your feedback..."
          style={{
            borderColor: Theme.colors.stroke.weak,
            color: Theme.colors.text.strong,
            backgroundColor: Theme.colors.background,
          }}
        />
      </div>

      <div className="w-full flex justify-center">
        <button
          onClick={handleSubmit}
          className="w-[50%] md:w-[30%] lg:w-[30%] p-2 rounded transition"
          style={{
            backgroundColor: Theme.colors.primary,
            color: "#FFFFFF",
          }}
        >
          Submit Feedback
        </button>
      </div>
    </div>
  </div>
</div>
  );
};

export default FeedbackModal;
